import type { To } from "react-router";

import { taskLink } from "@/features/tasks/hooks/useTaskParam";

export interface LinkTarget {
  to: To;
  state?: unknown;
}

/** Where a task outside any project opens: My Work, the page its people live in. */
const PROJECTLESS_TASK_PAGE = "/my-work";

/**
 * Open a task from anywhere: its project's page with the task panel over it
 * (/projects/NOON?task=NOON-12), or My Work for a task outside any project (/my-work?task=T-12).
 * Back closes the panel, as when it is opened on the board.
 */
export function taskTarget(projectKey: string | null, reference: string): LinkTarget {
  const link = taskLink(reference);
  const pathname = projectKey === null ? PROJECTLESS_TASK_PAGE : `/projects/${projectKey}`;
  return { to: { ...link.to, pathname }, state: link.state };
}

export function projectTarget(projectKey: string): LinkTarget {
  return { to: `/projects/${projectKey}` };
}
